/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as import0 from '@angular/core';
import * as import1 from '@angular/router';
import * as import2 from '@angular/common';
import * as import3 from '../../../app/server/server-ipmi.component';
import * as import4 from '../../../app/services/ipmi.service';
import * as import5 from '../../../app/services/api.service';
import * as import6 from '../../../app/services/response.service';
const styles_ServerIpmiComponent:any[] = ([] as any[]);
export const RenderType_ServerIpmiComponent:import0.RendererType2 = import0.ɵcrt({
  encapsulation: 2,
  styles: styles_ServerIpmiComponent,
  data: {}
}
);
export function View_ServerIpmiComponent_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
      (l()(),import0.ɵeld(0,(null as any),(null as any),17,'div',[[
        'class',
        'blocks header'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),4,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'h2',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['Dostęp do karty zarządzającej:'])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
      (l()(),import0.ɵeld(0,(null as any),(null as any),8,'div',[[
        'class',
        'options blocks'
      ]
    ],(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),5,'div',([] as any[]),(null as any),(null as any),(null as any),(null as any),(null as any))),
    (l()(),import0.ɵted((null as any),['\n            '])),
    (l()(),import0.ɵeld(0,(null as any),(null as any),2,'a',[
      [
        'class',
        'btn btn-medium'
      ]
      ,
      [
        'routerLink',
        '/messages/new'
      ]

    ]
    ,[
      [
        1,
        'target',
        0
      ]
      ,
      [
        8,
        'href',
        4
      ]

    ]
      ,[[
        (null as any),
        'click'
      ]
    ],(v,en,$event) => {
      var ad:boolean = true;
      if (('click' === en)) {
        const pd_0:any = ((<any>import0.ɵnov(v,13).onClick($event.button,$event.ctrlKey,$event.metaKey)) !== false);
        ad = (pd_0 && ad);
      }
      return ad;
    },(null as any),(null as any))),
    import0.ɵdid(671744,(null as any),0,import1.RouterLinkWithHref,[
      import1.Router,
      import1.ActivatedRoute,
      import2.LocationStrategy
    ]
      ,{routerLink: [
        0,
        'routerLink'
      ]
    },(null as any)),
    (l()(),import0.ɵted((null as any),['Zgłoś awarię'])),
    (l()(),import0.ɵted((null as any),['\n        '])),
    (l()(),import0.ɵted((null as any),['\n    '])),
    (l()(),import0.ɵted((null as any),['\n'])),
    (l()(),import0.ɵted((null as any),['\n']))
  ]
  ,(ck,v) => {
    const currVal_2:any = '/messages/new';
    ck(v,13,0,currVal_2);
  },(ck,v) => {
    const currVal_0:any = import0.ɵnov(v,13).target;
    const currVal_1:any = import0.ɵnov(v,13).href;
    ck(v,12,0,currVal_0,currVal_1);
  });
}
function View_ServerIpmiComponent_Host_0(l:any):import0.ɵViewDefinition {
  return import0.ɵvid(0,[
    (l()(),import0.ɵeld(0,(null as any),(null as any),1,'app-server-ipmi',([] as any[]),(null as any),(null as any),(null as any),View_ServerIpmiComponent_0,RenderType_ServerIpmiComponent)),
    import0.ɵdid(114688,(null as any),0,import3.ServerIpmiComponent,[
      import4.IpmiService,
      import1.ActivatedRoute,
      import5.ApiService,
      import6.ResponseService
    ]
    ,(null as any),(null as any))
  ]
  ,(ck,v) => {
    ck(v,1,0);
  },(null as any));
}
export const ServerIpmiComponentNgFactory:import0.ComponentFactory<import3.ServerIpmiComponent> = import0.ɵccf('app-server-ipmi',import3.ServerIpmiComponent,View_ServerIpmiComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9zZXJ2ZXIvc2VydmVyLWlwbWkuY29tcG9uZW50Lm5nZmFjdG9yeS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9zZXJ2ZXIvc2VydmVyLWlwbWkuY29tcG9uZW50LnRzIiwibmc6Ly8vc3RvcmFnZS92aG9zdC9wYW5lbC5kYXRhc3BhY2UucGwvd2ViL2RhdGFzcGFjZS1jcC1kcy1mcm9udC9zcmMvYXBwL3NlcnZlci9zZXJ2ZXItaXBtaS5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3N0b3JhZ2Uvdmhvc3QvcGFuZWwuZGF0YXNwYWNlLnBsL3dlYi9kYXRhc3BhY2UtY3AtZHMtZnJvbnQvc3JjL2FwcC9zZXJ2ZXIvc2VydmVyLWlwbWkuY29tcG9uZW50LnRzLlNlcnZlcklwbWlDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwiYmxvY2tzIGhlYWRlclwiPlxuICAgIDxkaXY+XG4gICAgICAgIDxoMj5Eb3N0xJlwIGRvIGthcnR5IHphcnrEhWR6YWrEhWNlajo8L2gyPlxuICAgIDwvZGl2PlxuICAgIDxkaXYgY2xhc3M9XCJvcHRpb25zIGJsb2Nrc1wiPlxuICAgICAgICA8ZGl2PlxuICAgICAgICAgICAgPGEgcm91dGVyTGluaz0nL21lc3NhZ2VzL25ldycgY2xhc3M9XCJidG4gYnRuLW1lZGl1bVwiPlpnxYJvxZsgYXdhcmnEmTwvYT5cbiAgICAgICAgPC9kaXY+XG4gICAgPC9kaXY+XG48L2Rpdj5cbiIsIjxhcHAtc2VydmVyLWlwbWk+PC9hcHAtc2VydmVyLWlwbWk+Il0sIm1hcHBpbmdzIjoiQUFBQTs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O01DQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUEyQjtJQUN2QjtJQUFLO0lBQ0Q7SUFBSTtJQUFtQztJQUNyQztNQUNOO1FBQUE7UUFBQTtNQUFBO0lBQUE7SUFBNEI7SUFDeEI7SUFBSztJQUNEO01BQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO01BQUE7O0lBQUE7S0FBQTtNQUFBO1FBQUE7UUFBQTtRQUFBO01BQUE7O01BQUE7UUFBQTtRQUFBO1FBQUE7TUFBQTs7SUFBQTtPQUFBO1FBQUE7UUFBQTtNQUFBO0lBQUE7TUFBQTtNQUFBO1FBQUE7UUFBQTtNQUFBO01BQUE7SUFBQTtnQkFBQTs7OztJQUFBO09BQUE7UUFBQTtRQUFBO01BQUE7SUFBQTtJQUFxRDtJQUFnQjtJQUNuRTtJQUNKO0lBQ0o7OztJQUhTO0lBQUgsVUFBRyxTQUFIOztJQUFBO0lBQUE7SUFBQSxVQUFBLG1CQUFBOzs7OztJQ05aO2dCQUFBOzs7OztJQUFBO0tBQUE7OztJQUFBOzs7In0=



// WEBPACK FOOTER //
// ./src/$$_gendir/app/server/server-ipmi.component.ngfactory.ts